import { useSelector } from 'react-redux';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { HIDDEN } from 'customer-data-objects/property/AccessLevel';
import ScoreRing from 'sales-execution-components/components/scoreRing/ScoreRing';
import PropertyInputHidden from './PropertyInputHidden';
import { getProperties } from '../../selectors/properties';
import { getUseForDealScoreValue } from '../../utils/deals';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DealScoreCell = ({
  row,
  columnName,
  requiredCellProps
}) => {
  var _row$properties;
  const propertyDefinition = useSelector(getProperties)[columnName];

  // Since this is a handrolled cell renderer, we must manually handle access ourselves
  const accessLevel = useAccessLevel({
    objectType: 'DEAL',
    propertyName: columnName
  });
  const isHiddenAccess = accessLevel === HIDDEN;
  const propertyValue = row === null || row === void 0 || (_row$properties = row.properties) === null || _row$properties === void 0 || (_row$properties = _row$properties[columnName]) === null || _row$properties === void 0 ? void 0 : _row$properties.value;
  const scoreValue = propertyValue ? Number(propertyValue) : 0;
  const use = getUseForDealScoreValue(scoreValue);
  const renderScoreRing = () => propertyValue ? /*#__PURE__*/_jsx(ScoreRing, {
    use: use,
    value: scoreValue
  }) : '--';
  return /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "end",
      children: [isHiddenAccess && /*#__PURE__*/_jsx(PropertyInputHidden, {
        property: propertyDefinition
      }), !isHiddenAccess && renderScoreRing()]
    })
  }));
};
export default DealScoreCell;